import { createContext } from 'react';
import { API } from '@shared/types/api';

type CardChannelContextType = API.ChannelFragment | undefined;

export const CardChannelContext = createContext<CardChannelContextType>(undefined);
